import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { useAdminContext } from '../../context/adminContext';
import { S3_URL } from '../../utils/BaseUrl';
import { capitalizeWords, dateFormat } from '../../utils/HelperFuncitons';
import LimitPagination from '../common/LimitPagination';
import ImageViewModal from '../common/Modal/ImageViewModal';
import CommonTable from '../common/Table/CommonTable';
import { getAllRestaurantApi, getPartnerAllReviewApi } from '../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';

function PartnerReviewTable({ id }) {
   const [loader, setLoader] = useState(false);
   const [details, setDetails] = useState([]);
   const [selectedPage, setSelectedPage] = useState(1);
   const [search, setSearch] = useState("");
   const [totalCount, setTotalCount] = useState(null);
   const [page, setPage] = useState(0);
   const { limit } = useAdminContext();
   const imageViewModalId = "imageViewModalId"
   const [selectedImg, setSelectedImg] = useState("")
   let currentPage = "";


   const handlePageClick = (event) => {
      currentPage = event.selected + 1;
      getPartnerAllReviewList(currentPage, limit)
      setSelectedPage(currentPage)
   };

   async function getPartnerAllReviewList() {
      try {
         setLoader(true);
         const res = await getPartnerAllReviewApi(id, limit, currentPage, search, "", "");
         if (res.status === 200 || res.status === 201) {
            const data = res?.data?.data?.reveiwList;
            const totalLength = res?.data?.data?.totalLength;
            setTotalCount(totalLength);
            setPage(Math.ceil(totalLength / limit));
            setDetails(data);
            setLoader(false);
         }
      } catch (error) {
         toast.error(error.message);
         setLoader(false);
      }
   }


   const headerData = [
      { name: "S.No", className: "col-1", key: "index" },
      { name: "Name", className: "col-4", key: "name" },
      { name: "Type", className: "col-1", key: "rideType" },
      { name: "Ratings", className: "col-1", key: "ratings" },
      { name: "Compliment", className: "col-1", key: "compliment" },
      { name: "Created", className: "col-1", key: "createdAt" },

   ]

   const tableData = details?.map((item, index) => ({
      index: index + 1,
      name: (
         <>
            <div className="avatar avatar-xs align-middle me-2">
               <img
                  className="avatar-img rounded-circle"
                  src={!item?.user?.profileImage ? "/images/profiledp.png" : `${S3_URL}/${item?.user?.profileImage}`}
                  alt="img"
                  data-bs-toggle="modal"
                  data-bs-target={`#${imageViewModalId}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => { setSelectedImg(!item?.user?.profileImage ? "/images/profiledp.png" : `${S3_URL}/${item?.user?.profileImage}`) }}
               />
            </div>
            <Link to={`/customers/${item?.user?.id}`}>{item?.user?.firstName ? capitalizeWords(`${item?.user?.firstName} ${item?.user?.lastName}`) : "-"}</Link>
         </>),
      rideType: item?.rideType || "-",
      ratings: item?.ratings || "-",
      compliment: item?.compliment || "-",
      createdAt: item?.createdAt ? dateFormat(item?.createdAt) : "-",
   }))

   useEffect(() => {
      getPartnerAllReviewList()
   }, [])

   return (
      <>
         <div className="d-flex justify-content-end flex-wrap align-items-center mt-3 mt-lg-0">
            <LimitPagination getData={getPartnerAllReviewList} />
         </div>
         <CommonTable headers={headerData} data={tableData} loading={loader} />
         <ImageViewModal imgUrl={selectedImg} modalId={imageViewModalId} />

         {totalCount > limit ? (
            <div className="d-flex justify-content-center">
               <ReactPaginate
                  nextLabel="Next >"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                  pageCount={page}
                  previousLabel="< Previous"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName={"active"}
                  forcePage={selectedPage - 1}
               />
            </div>
         ) : (
            ""
         )}
      </>
   )
}

export default PartnerReviewTable